// @flow strict
import "~robin-hood/globals";

import React from "react";
// $FlowFixMe[missing-export]
import { FirebaseAppProvider } from "reactfire";
import RobinHoodApp from "./RobinHoodApp";

var firebaseConfig = {
  apiKey: "AIzaSyA5CUCH4sJLPMoT9-Qr3hbXaCzTSH6jGHQ",
  authDomain: "el-gato-encerrado.firebaseapp.com",
  databaseURL: "https://el-gato-encerrado.firebaseio.com",
  projectId: "el-gato-encerrado",
  storageBucket: "el-gato-encerrado.appspot.com",
  messagingSenderId: "882675804263",
  appId: "1:882675804263:web:8a99f74bfbf3ece65c0cc2",
};

export default function Root(): React$Node {
  return (
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
      <RobinHoodApp />
    </FirebaseAppProvider>
  );
}
